import { render, staticRenderFns } from "./TranProgramList.vue?vue&type=template&id=60590f10&scoped=true"
import script from "./TranProgramList.vue?vue&type=script&lang=js"
export * from "./TranProgramList.vue?vue&type=script&lang=js"
import style0 from "./TranProgramList.vue?vue&type=style&index=0&id=60590f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60590f10",
  null
  
)

export default component.exports